import styled from '@emotion/styled'

import { focusVisible } from '@/styles/mixins'
import { mediaUp } from '@/styles/media'
import { colors } from '@/styles/theme'
import { Text2Styles } from '@/styles/typography'
import { sliderButtons } from '@/styles/slider'

const commonButtonStyle = `
  background: none;
  border: none;
  cursor: pointer;
`

const commonFontStyle = `
  font-style: normal;
  font-family: Nunito;
  font-weight: 700;
`

const commonBlockStyle = `
  display: flex;
  justify-content: center;
  align-items: center;
`

export const IconButton = styled.button<{
  open: boolean
  short: boolean
  size?: 'S' | 'M'
}>`
  ${focusVisible};
  position: relative;
  cursor: pointer;
  width: 16px;
  height: 16px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  margin-top: 2px;

  &::after,
  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 2px;
    left: 50%;
    top: 50%;
    border-radius: 5px;
    background-color: ${props =>
      props.size === 'S'
        ? colors.white
        : props.open && !props.short
        ? colors.greenishCyan
        : colors.twilightBlue};
    transition: transform 0.15s ease;
  }

  &::after {
    transform: translate3d(-50%, calc(-50% + 4px), 0);

    ${props =>
      (props.open || props.short) &&
      `
      transform: translate3d(-50%, -50%, 0) rotate(-45deg);
    `};
  }

  &::before {
    transform: translate3d(-50%, calc(-50% - 4px), 0);

    ${props =>
      (props.open || props.short) &&
      `
      transform: translate3d(-50%, -50%, 0) rotate(45deg);
    `};
  }
`

export const CloseButton = styled.button<{ customStyle?: React.CSSProperties }>`
  ${commonButtonStyle}
  padding: 0;
  margin: 0;
  ${({ customStyle }) => customStyle && { ...customStyle }}
`

export const SearchButton = styled.button<{
  customStyle?: any
}>`
  ${commonFontStyle}
  ${commonBlockStyle}
  
  ${({ customStyle }) => customStyle && customStyle}
`

export const FileButton = styled.button`
  ${Text2Styles};
  display: block;
  margin: 0 auto;
  color: ${colors.darkCoral};
  pointer-events: all;
`

export const TextButton = styled.button<{ customStyle?: React.CSSProperties }>`
  ${commonFontStyle}
  font-weight: 600;
  font-size: 12px;
  border: unset;
  width: 130px;

  ${mediaUp('md')} {
    font-size: 13px;
    width: unset;
  }

  ${mediaUp('lg')} {
    font-size: 16px;
    width: unset;
  }
  ${({ customStyle }) => customStyle && { ...customStyle }}
`

export const OptionsButton = styled.button<{
  customStyle?: any
}>`
  ${commonButtonStyle}
  ${commonFontStyle}
  ${({ customStyle }) => customStyle && customStyle}
`

export const MonthsButton = styled.button<{
  customStyle?: React.CSSProperties
}>`
  ${commonBlockStyle}
  ${({ customStyle }) => customStyle && { ...customStyle }}
`

export const ButtonWrapper = styled.button<{
  customStyle?: React.CSSProperties
}>`
  ${sliderButtons};
  ${({ customStyle }) => customStyle && { ...customStyle }}
`
